<section id="occupational-profile-orientation"  class="o-wrapper bg-blue-100">
	<div class="o-2-col -sidearea  c-rubriek-block -img-bottom">
		<div class="c-rubriek-block__textblock">
			<h2>Is {{occupationalProfileTitle}} toch niets voor jou?</h2>
			<p>Ontdek welke job wel bij je past en wat je mogelijkheden zijn op de arbeidsmarkt. </p>
			<div class="o-btn-group">
				<a href="{{orienationtestUrlObservable | async}}" class="c-btn -primary">Alles om je te oriënteren </a>
			</div>
		</div>
		<div class="c-rubriek-block__imageblock">
			<img class="c-rubriek-block__image"
				 src="/cdn/img/components/orienteren.svg" alt="">
		</div>
	</div>
</section>
